module.exports = "build/assets/iceberg2.20f86c05.png";